import './CoupleName.css';

export default function CoupleName() {
    return (<section id="couple-name" className="hero is-fullheight">
        <div className="hero-body">
            <div className="container has-text-centered has-text-white">
                <p className="subtitle">Pernikahan</p>
                <p className="title">Meti & Bervi</p>
                <p className="subtitle">Sabtu, 18 Januari 2025</p>
            </div>
        </div>
    </section>);
}